// in src/App.js
import React from 'react';
import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import AppLayout from './components/AppLayout';
import Dashboard from './components/Dashboard';
import LoginPage from './components/account/LoginPage';
import Account from './components/account/Account';
import ForgotPassword from './components/account/ForgotPassword';
import ResetPassword from './components/account/ResetPassword';
import Support from './components/Support';
import Marketing from './components/Marketing';

import events from './components/events';

import theme from './style/theme';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import i18nProvider from './i18n/i18nProvider';

import { addUploadFeature } from './services/dataProviderFeatures';

const customDataProvider = addUploadFeature(dataProvider);

const App = () => (
    <BrowserRouter basename="/admin">
        <Admin
            layout={AppLayout}
            dashboard={Dashboard}
            loginPage={LoginPage}
            dataProvider={customDataProvider}
            authProvider={authProvider}
            title="Europe Remembers"
            theme={theme}
            disableTelemetry
            i18nProvider={i18nProvider}
        >
            <Resource name="events" {...events} />
            <CustomRoutes>
                <Route path="/account" element={<Account />} />
                <Route path="/support" element={<Support />} />
                <Route path="/marketing" element={<Marketing />} />
            </CustomRoutes>
            <CustomRoutes noLayout>
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
            </CustomRoutes>
        </Admin>
    </BrowserRouter>
);

export default App;
